import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import type { SeriesRow_PostFragment } from '../graphql/generated/graphqlTypes';
import PostTitleWithIcons from '../post/PostTitleWithIcons';
import postPath from '../utils/url/postPath';
import styles from './SeriesRow.module.scss';

const POST_FRAGMENT = gql`
  fragment SeriesRow_post on RootPostFields {
    title
    ...postPath_post
    ...PostTitleWithIcons_post
  }
  ${PostTitleWithIcons.fragments.post}
  ${postPath.fragments.post}
`;

interface SeriesRowProps {
  active?: boolean;
  index: number;
  post: SeriesRow_PostFragment;
  noLink?: boolean;
  noPadding?: boolean;
}

const SeriesRow = ({
  active = false,
  index,
  post,
  noLink = false,
  noPadding = false,
}: SeriesRowProps) => {
  const commonProps = {
    className: classNames(styles.row, {
      [styles.active]: active,
      [styles.noLink]: noLink,
      [styles.noPadding]: noPadding,
    }),
  };
  const children = (
    <>
      <span className={styles.number}>{index + 1}</span>
      <span className={styles.title}>
        <PostTitleWithIcons post={post} iconSize="small" />
      </span>
    </>
  );

  return noLink ? (
    <div {...commonProps}>{children}</div>
  ) : (
    <Link to={postPath(post)} {...commonProps}>
      {children}
    </Link>
  );
};

SeriesRow.fragments = {
  post: POST_FRAGMENT,
};

export default SeriesRow;
